import { createRestApiClient } from '..';
import { getUserToken } from '../../Utils/helper';
import { getUserTokenSSR } from '../../Utils/commonUtils';
import { getWebUserType } from '../../Utils/getWebUserType';
import { fireEvent } from '../../Utils/fireEvent';
const restApiClient = createRestApiClient();
const userType = getWebUserType();

export const getOrderDetails = async (order_id, params, cookieString) => {
  const url = `/api/getOrderData/${order_id}`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error(err);
    });
  return data;
};

export const getSrOrderDetails = async (sr_order_id) => {
  const url = `/api/checkStatusForSrOrderId`;
  const params = {
    sr_order_id: sr_order_id,
  };

  return await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => {
      return res?.data?.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const checkCreateNuxUrl = async (nuxId) => {
  const url = `new/nuxTooltip/getNuxToolTipByNuxId?nux_id=${nuxId}`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error(err);
    });

  return data;
};

export const postOrderFeedback = async (body) => {
  const restApiClient = createRestApiClient();
  const url = `new/postOrder/postPostOrderFeedback`;

  await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: body,
      headers: {
        'Content-Type': 'application/json',
        'authorization': getUserToken(true),
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
    });
};

export const getOrderStatusData = async (order_id) => {
  const url = `/api/getOrderStatusLog`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
      params: {
        order_id: order_id,
      },
    })
    .then((res) => {
      return res?.data?.data;
    })
    .catch((err) => {
      console.error(err);
    });
  return data;
};
